import { render, staticRenderFns } from "./PanelMask.vue?vue&type=template&id=1dcc87c2&scoped=true&"
import script from "./PanelMask.vue?vue&type=script&lang=ts&"
export * from "./PanelMask.vue?vue&type=script&lang=ts&"
import style0 from "./PanelMask.vue?vue&type=style&index=0&id=1dcc87c2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcc87c2",
  null
  
)

export default component.exports